import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { UseFormRegisterReturn } from 'react-hook-form';  
import { Input, FormControl, Select } from '@material-ui/core';
import { Palette } from 'core/config';
import IMAGES from 'assets/images';

interface Props
{
    name          : string;
    label?        : string;
    required?     : boolean;
    initialValue? : any;
    options       : Array<{ value : string; label : string; }>;
    setValue      : (name : string, value : any) => void;
    input         : UseFormRegisterReturn;
}

export const OptionSelect : React.FunctionComponent<Props> = ({
    name,
    label, 
    required,
    initialValue,
    options,
    setValue,
    input 
}) =>
{
    const [ selected, setSelected ] = useState<string>(initialValue ?? '0');

    useEffect(() =>
    { 
        // Set initial value on mount
        setValue(name, initialValue ?? '0');
    }, [ setValue ]);

    const onChange = (e : React.ChangeEvent<any>) =>
    { 
        const value = e.target.value;
        setSelected(value);
        setValue(name, value);
    };

    return (
        <Container>
            <SelectContainer required={required}>
                {label && <Label>{label}</Label>}
                <SelectDropdown
                    id='select-name'
                    value={selected}
                    onChange={onChange}
                    name='name'
                    input={<Input id='dropdown-select' />}
                    IconComponent={() => <DropdownIcon src={IMAGES.icExpand} />}
                >
                    {options && options.length && options.map((option, i) => // @ts-ignore
                        <SelectOption key={`select-option-${i}`} value={option.value}>
                            {option.label}
                        </SelectOption>
                    )}
                </SelectDropdown>
            </SelectContainer>
            <HiddenInput {...input} />
        </Container>
    );
};

const Container = styled.div`
    margin-left: 60px;
    margin-right: 60px;
`;

const Label = styled.div`
    margin-top: 20px;
    margin-bottom: 5px;
    color: ${Palette.BLUE};
    font-size: 10px;
    font-family: 'SofiaPro-Regular';

    @media only screen and (min-width: 1300px) {
        font-size: 12px;
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
    }
`;

const SelectContainer = styled(FormControl)`
    cursor: pointer;

    .MuiInput-underline::after {
        border: none;
    }

    .MuiInput-underline::before {
        border: none;
        content: none;
    }

    .MuiInputBase-root {
        width: 299px;
    }

    #select-name {
        background-color: transparent;
        margin-left: -13px;
        padding-left: 15px;
        padding-right: 30px;
        color: ${Palette.BLUE};
        font-size: 12px;
        font-family: 'SofiaPro-Regular';

        @media only screen and (min-width: 1900px) {
            font-size: 14px;
            white-space: nowrap;
        }
    }
`;

const SelectDropdown = styled(Select)`
    background-color: ${Palette.EGGSHELL_WHITE};
    border-radius: 11px;
    height: 37px;
    padding-left: 15px;
    cursor: pointer;
`;

const SelectOption = styled.div`
    color: ${Palette.BLUE};
    font-size: 12px;
    font-family: 'SofiaPro-Regular';
    user-select: none;
    padding: 10px 10px 10px 15px;
    background-color: ${Palette.EGGSHELL_WHITE};

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
    }

    &:hover {
        background-color: ${Palette.TAN};
        cursor: pointer;
    }
`;

const DropdownIcon = styled.img`
    position: absolute;
    right: 10px;
    cursor: pointer;
`;

const HiddenInput = styled.input`
    position: absolute;
    visibility: hidden;
`;